import CheckoutPage from './pages/CheckoutPage';
import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import SuperAdminRoute from './components/SuperAdminRoute';
import AdminRoute from './components/AdminRoute';
import SuperAdminLayout from './pages/super-admin/SuperAdminLayout';

// Loading Component
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="relative">
      <div className="w-16 h-16 border-4 border-blue-200 dark:border-blue-900 rounded-full"></div>
      <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin absolute top-0 left-0"></div>
      <div className="mt-4 text-center text-gray-600 dark:text-gray-400 font-medium">
        Carregando...
      </div>
    </div>
  </div>
);

// Lazy load das páginas
const Dashboard = lazy(() => import('./pages/dashboard'));
const ProductManagement = lazy(() => import('./pages/product-management'));
const StockManagement = lazy(() => import('./pages/stock'));
const FinancialReports = lazy(() => import('./pages/financial-reports'));
const Settings = lazy(() => import('./pages/settings'));
const Billing = lazy(() => import('./pages/Billing'));
const Companies = lazy(() => import('./pages/companies'));
const Users = lazy(() => import('./pages/users'));
const Subscriptions = lazy(() => import('./pages/subscriptions'));
const Activities = lazy(() => import('./pages/activities'));
const Landing = lazy(() => import('./pages/Landing'));
const Login = lazy(() => import('./pages/login'));
const Register = lazy(() => import('./pages/register'));
const SubscriptionBlocked = lazy(() => import('./pages/SubscriptionBlocked'));
const NotFound = lazy(() => import('./pages/NotFound'));

// Super Admin Pages
const SuperAdminDashboard = lazy(() => import('./pages/super-admin/Dashboard'));
const SuperAdminCompanies = lazy(() => import('./pages/super-admin/Companies'));
const SuperAdminSubscriptions = lazy(() => import('./pages/super-admin/Subscriptions'));
const SuperAdminFinancial = lazy(() => import('./pages/super-admin/Financial'));
const SuperAdminCreateAdmins = lazy(() => import('./pages/super-admin/CreateAdmins'));
const SuperAdminConversations = lazy(() => import('./pages/super-admin/Conversations'));

// Admin Company Pages
const AdminControl = lazy(() => import('./pages/admin-control'));

export default function AppRoutes() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        {/* Landing page (pública) */}
        <Route path="/" element={<Landing />} />
        {/* Rotas públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/subscription-blocked" element={<SubscriptionBlocked />} />

        {/* Rotas Super Admin (apenas para admin master) */}
        <Route element={<SuperAdminRoute><SuperAdminLayout /></SuperAdminRoute>}>
          <Route path="/super-admin" element={<SuperAdminDashboard />} />
          <Route path="/super-admin/companies" element={<SuperAdminCompanies />} />
          <Route path="/super-admin/subscriptions" element={<SuperAdminSubscriptions />} />
          <Route path="/super-admin/financial" element={<SuperAdminFinancial />} />
          <Route path="/super-admin/users" element={<SuperAdminCreateAdmins />} />
          <Route path="/super-admin/conversations" element={<SuperAdminConversations />} />
          <Route path="/admin/conversations" element={<SuperAdminConversations />} />
        </Route>

        {/* Rotas Admin de Empresa (não master) */}
        <Route element={<AdminRoute><Layout /></AdminRoute>}>
          <Route path="/admin-control" element={<AdminControl />} />
        </Route>

        {/* Rotas protegidas com Layout */}
        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/product-management" element={<ProductManagement />} />
          <Route path="/products" element={<Navigate to="/product-management" replace />} />
          <Route path="/stock" element={<StockManagement />} />
          <Route path="/financial-reports" element={<FinancialReports />} />
          <Route path="/financial" element={<Navigate to="/financial-reports" replace />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/companies" element={<Companies />} />
          <Route path="/users" element={<Users />} />
          <Route path="/subscriptions" element={<Subscriptions />} />
          <Route path="/activities" element={<AdminRoute><Activities /></AdminRoute>} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
